export const environment = {
  production: false,
  name: 'dev',
  projectName: 'RUBi',
  defaultTheme: 'RUBi',
  version: '1.1.2',
  region: 'us-gov-west-1',
  url: 'https://rubi-dev.cristlgov.com',
  endpoint: 'https://rubi-be-dev.cristlgov.com',
  sandboxEnabled: false,
  uamUrl: 'https://dev.cristlgov.com/',
  refreshEndpoint: 'https://dev-be.cristlgov.com/auth/refreshToken',
  boardsEnabled: true,
  cookieInfo: {
    domain: '.cristlgov.com',
  }
};
